'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRouterRedux = require('react-router-redux');

var _richMediaConstants = require('./richMediaConstants');

var _draggingConstants = require('../../reducers/draggingConstants');

// Constants
var initialState = _richMediaConstants.RICH_MEDIA_STATE.PREVIEW; // Lib

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _richMediaConstants.RICH_MEDIA_EMBEDDING:
            return _richMediaConstants.RICH_MEDIA_STATE.EMBEDDING;
        case _richMediaConstants.RICH_MEDIA_READY:
            return _richMediaConstants.RICH_MEDIA_STATE.READY;
        case _richMediaConstants.RICH_MEDIA_ERROR:
            return _richMediaConstants.RICH_MEDIA_STATE.ERROR;
        case _richMediaConstants.RICH_MEDIA_RETURN_TO_PREVIEW:
        case _draggingConstants.DRAG_START:
        case _reactRouterRedux.LOCATION_CHANGE:
            return initialState;
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/richMedia/richMediaContentStateReducer.js
// module id = 2021
// module chunks = 0